export const L10N = {
  ACTION_PAY: { id: 'core.action.pay' },

  LABEL_CARD_NAME: { id: 'core.label.card_name' },
  LABEL_CARD_NAME_ERROR: { id: 'core.label.card_name_error' },

  NOTIFICATION_ERROR: { id: 'common.notification.error_unknown' },
};
